import { render, staticRenderFns } from "./variation-grid-item.vue?vue&type=template&id=f4804b84&"
import script from "./variation-grid-item.vue?vue&type=script&lang=js&"
export * from "./variation-grid-item.vue?vue&type=script&lang=js&"
import style0 from "./variation-grid-item.vue?vue&type=style&index=0&id=f4804b84&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports